// import { Pagination, Grid } from '@mui/material';

// const CustomPagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
//   const totalPages = Math.ceil(totalItems / itemsPerPage);

//   return (
//     <Grid container justifyContent="center" sx={{ mt: 4 }}>
//       <Pagination
//         count={totalPages}
//         page={currentPage}
//         onChange={(event, value) => onPageChange(value)}
//         color="primary"
//         shape="rounded"
//         size="large"
//         showFirstButton
//         showLastButton
//       />
//     </Grid>
//   );
// };

// export default CustomPagination;
import { Pagination, Grid } from '@mui/material';

const CustomPagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(event, value) => onPageChange(value)}
        color="primary"
        shape="rounded"
        size="large"
        showFirstButton
        showLastButton
        sx={{
          '& .MuiPaginationItem-root': {
            border: '2px solid #c1721f',
            color: '#c1721f',
            backgroundColor: '#fff',
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: '#c1721f',
            color: '#fff',
          },
        }}
      />
    </Grid>
  );
};

export default CustomPagination;
